import React from 'react';
import {useState, useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../authentication/AuthContext'; // Import the AuthContext
import logo from '../assets/images/logo.png';
import "../styles/navbar.css";
import login_icon from '../assets/icons/login.svg';
import { MdMenu } from 'react-icons/md';
import homeIcon from "../assets/icons/home.png";

function Navbar() {
  // Get authentication status and logout function from the AuthContext
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate(); 
  const [authStatus, setAuthStatus] = useState(isAuthenticated);
  useEffect(() => {
    setAuthStatus(isAuthenticated);
  }, [isAuthenticated]);

    const navLinks = [
        {
            link : "/",
            text : null,
            icon: <img src={homeIcon} alt="Home" style={{ 
                width: '24px',      
                height: '24px',      
                background: 'transparent', 
                border: 'none',      
                verticalAlign: 'middle', 
                mixBlendMode: 'darken',
                
            }} />, 
            dropdown : false,
        },
        {
            link : "",
            text : "KNOW YOUR BANK",
            className : "know_your_bank",
            dropdown : [true, [
                {
                    link : "/about",
                    text : "ABOUT US",   
                },
                {
                    link : "/bod",
                    text : "BOARD OF DIRECTORS",   
                },
                {
                    link : "/management-executives",
                    text : "MANAGEMENT EXECUTIVES",   
                },
                {
                    link : "/branches-and-bank-timings",
                    text : "BRANCHES AND BANK TIMING",   
                },
                {
                    link : "/annual-report",
                    text : "ANNUAL REPORT",   
                },
                {
                    link : "/future-plans",
                    text : "FUTURE PLANS",   
                },
            ]],
        },

        {
            link : "",
            text : "INTEREST RATES",
            className:"interest_rates",
            dropdown : [true, [
                {
                    link : "/deposit-interest-rates",
                    text : "DEPOSIT INTEREST",   
                },
                {
                    link : "/loan-interest-rates",
                    text : "LOAN INTEREST",   
                },
            ]],
        },

        {
            link : "/loans",
            text : "LOANS",
            dropdown : false,
        },

        {
            link : "",
            text : "DEPOSITS",
            className : 'deposits',
            dropdown : [true, [
                {
                    link : "/deposits/savings-account",
                    text : "SAVING BANK ACCOUNT",   
                },
                {
                    link : "/deposits/current-account",
                    text : "CURRENT ACCOUNT",   
                },
                {
                    link : "/deposits/fixed-deposit",
                    text : "FIXED DEPOSITS & KCC",   
                },
                {
                    link : "/deposits/recurring-deposit",
                    text : "RECURRING DEPOSITS",   
                },
                {
                    link : "/deposits/daily-deposit",
                    text : "DAILY DEPOSITS",   
                },
            ]],
        },

        {
            link : "",
            text : "FACILITIES",
            className : 'facilities_list',
            dropdown : [true, [
                {
                    link : "/facilities/rtgs-neft",
                    text : "RTGS/NEFT",   
                },
                {
                    link : "/facilities/bank-guarantee",
                    text : "BANK GUARANTEE",   
                },
                {
                    link : "/facilities/membership",
                    text : "MEMBERSHIP",   
                },
                {
                    link : "/facilities/lockers",
                    text : "LOCKERS",   
                },
                {
                    link : "/facilities/abb_services",
                    text : "ABB SERVICES",   
                },
            ]],
        },

        {
            link : "/gallery",
            text : "GALLERY",
            dropdown : false,
        },

        {
            link : "/contact-us",
            text : "CONTACT US",
            dropdown : false,
        },
    ];

    function menu(){
        let navLinks = document.getElementsByClassName('navLinks')[0];
        navLinks.style.display = navLinks.style.display === "flex"? "none" : "flex";
    }

    const handleLogOut = () => {
      logout();
      navigate('/');
    };

    return (
        <div className="nav" 
          style={{
    position: 'fixed', 
    top: '0', 
    left: '0', 
    width: '100%', 
    padding: '10px 0', 
    zIndex: 25
  }}
        >
          <div className="left">
            <Link to="/">
              <img className="logo" src={logo} alt="logo" style={{marginLeft : "5px"}} />
            </Link>
            <MdMenu onClick={menu} />
          </div>
          <div>
            <p className="title">THE TALIKOTI SAHAKARI BANK NIYAMIT</p>
            <div className="navLinks">
              {navLinks.map((item) => {
                if (item.dropdown[0]) {
                  return (
                    <div key={item.text}>
                      {item.icon ? (
                        <Link to={item.link}>{item.icon}</Link>
                      ) : (
                        <Link to={item.link}>{item.text}</Link>
                      )}
                      <li className={item.className}>
                        {item.dropdown[1].map((i) => (
                          <Link key={i.text} to={i.link}>
                            {i.text}
                          </Link>
                        ))}
                      </li>
                    </div>
                  );
                } else {
                  return (
                    <div key={item.text}>
                      {item.icon ? (
                        <Link to={item.link}>{item.icon}</Link>
                      ) : (
                        <Link to={item.link}>{item.text}</Link>
                      )}
                    </div>
                  );
                }
              })}
            </div>
          </div>
          <div>
           {authStatus ? (  
          <button onClick={handleLogOut}>Logout</button>
        ) : (
          <Link className="login" to="/login">
            <img src={login_icon} alt="Login" />
          </Link>
        )}
          </div>
        </div>
      );
    }
    
    export default Navbar;